import { Pipe, PipeTransform } from '@angular/core';
import { Employee } from '../../api/generated';

@Pipe({ name: 'name' })
export class NamePipe implements PipeTransform {
  transform(user: Employee): string {
    return user ? NamePipe.formatEmployee(user) : '';
  }

  public static formatEmployee(employee: Employee): string {
    if (!employee) return '';
    const displayFistName =
      employee.preferredFirstName && employee.preferredFirstName.trim() !== ''
        ? employee.preferredFirstName
        : (employee.firstname ?? '');

    const displayLastName =
      employee.preferredSurname && employee.preferredSurname.trim() !== ''
        ? employee.preferredSurname
        : (employee.lastname ?? '');

    return [employee.title, displayFistName, employee.lastnamePrefix, displayLastName]
      .filter(part => !!part && part.trim() !== '')
      .join(' ')
      .trim();
  }
}
